import { FC } from "react";

const CornerTri: FC = () => (
  <span
    className="absolute border-solid bottom-0 left-0 border-l-white border-t-[transparent] z-10
border-t-[5vw] lg:border-t-[50px]
border-l-[5vw] lg:border-l-[50px]"
  ></span>
);

export default CornerTri;
